/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { OffsetDateTime } from "@freightsimple/time/branded-types";

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface TeamNoteDto
 */
export interface TeamNoteDto {
  /**
   *
   * @type {string}
   * @memberof TeamNoteDto
   */
  noteId: string;
  /**
   *
   * @type {string}
   * @memberof TeamNoteDto
   */
  authorEmail: string;
  /**
   *
   * @type {string}
   * @memberof TeamNoteDto
   */
  body: string;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof TeamNoteDto
   */
  createdAt: OffsetDateTime;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof TeamNoteDto
   */
  updatedAt: OffsetDateTime;
}

/**
 * Check if a given object implements the TeamNoteDto interface.
 */
export function instanceOfTeamNoteDto(value: object): value is TeamNoteDto {
  if (!("noteId" in value) || value["noteId"] === undefined) return false;
  if (!("authorEmail" in value) || value["authorEmail"] === undefined)
    return false;
  if (!("body" in value) || value["body"] === undefined) return false;
  if (!("createdAt" in value) || value["createdAt"] === undefined) return false;
  if (!("updatedAt" in value) || value["updatedAt"] === undefined) return false;
  return true;
}

export function TeamNoteDtoFromJSON(json: any): TeamNoteDto {
  return TeamNoteDtoFromJSONTyped(json, false);
}

export function TeamNoteDtoFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): TeamNoteDto {
  if (json == null) {
    return json;
  }
  return {
    noteId: json["noteId"],
    authorEmail: json["authorEmail"],
    body: json["body"],
    createdAt: json["createdAt"],
    updatedAt: json["updatedAt"],
  };
}

export function TeamNoteDtoToJSON(json: any): TeamNoteDto {
  return TeamNoteDtoToJSONTyped(json, false);
}

export function TeamNoteDtoToJSONTyped(
  value?: TeamNoteDto | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    noteId: value["noteId"],
    authorEmail: value["authorEmail"],
    body: value["body"],
    createdAt: value["createdAt"],
    updatedAt: value["updatedAt"],
  };
}
